import { ToastContainer } from '../../components/ui/toast';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import './Login.css';

/**
 * AuthScreen — split-screen auth with a Sign in / Create account tab switch.
 * Left: Pram Express wallpaper. Right: form panel with shadcn-style tabs.
 * Rendered at both `/` (Sign in) and `/Register` (Create account) — the route
 * only decides which tab is active initially.
 *
 * @param {string} defaultTab  "login" | "register"
 */
function AuthScreen({ defaultTab }) {
    return (
        <>
            <ToastContainer />
            <div className="pxl-container">
                {/* Left: wallpaper / branding */}
                <div className="pxl-left">
                    <img className="pxl-wallpaper" src="/assets/img/pram-wallpaper.png" alt="" />
                    <div className="pxl-left-brand">
                        <span className="pxl-left-brand__name">PRAM EXPRESS</span>
                        <span className="pxl-left-brand__sub">Courier &amp; Hyperlocal Delivery</span>
                    </div>
                </div>

                {/* Right: form panel with tab switch */}
                <div className="pxl-right">
                    <div className="pxl-box">
                        <a href="https://pramexpress.com/" target="_blank" rel="noopener noreferrer"><img className="pxl-logo" src="/assets/img/logo.png" alt="Pram Express" /></a>

                        <Tabs defaultValue={defaultTab}>
                            <TabsList>
                                <TabsTrigger value="login">Sign in</TabsTrigger>
                                <TabsTrigger value="register">Create account</TabsTrigger>
                            </TabsList>

                            <TabsContent value="login">
                                <h2 className="pxl-title">Sign in to Pram Express</h2>
                                <p className="pxl-sub">Enter your details to access your account</p>
                                <LoginForm />
                            </TabsContent>

                            <TabsContent value="register">
                                <h2 className="pxl-title">Create your account</h2>
                                <p className="pxl-sub">Enter your details to set up your account</p>
                                <RegisterForm />
                            </TabsContent>
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AuthScreen;
